import { createContext, useCallback, useContext, useEffect, useState, useMemo } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(undefined);
  const refresh = useCallback(async () => {
    try {
      setCustomer(await api.customerMe());
    } catch {
      setCustomer(null);
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  const login = (data) => setCustomer(data.customer);
  const logout = async () => {
    try { await api.customerLogout(); } catch (err) { console.warn("Logout cliente lato server non riuscito:", err); }
    setCustomer(null);
  };
  const value = useMemo(() => ({ customer, login, logout, refresh, setCustomer }), [customer, refresh]); // eslint-disable-line react-hooks/exhaustive-deps
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useCustomer = () => useContext(Ctx);
